<ng-container *ngIf="dtOptions">
    <!-- <div class="table-responsive"> -->
    <table datatable [dtOptions]="dtOptions" class="row-border hover">
      <ng-container *ngIf="headerTemplate">
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      </ng-container>
      <ng-container *ngIf="bodyTemplate">
        <ng-container
          *ngTemplateOutlet="bodyTemplate; context: { $implicit: data }">
        </ng-container>
      </ng-container>
    </table>
    <!-- </div> -->
  </ng-container>